module.exports = __webpack_public_path__ + "static/media/29COICT10.5d25a45e.jpg";